

import templateThankYouPage from '@/app-template/lib/pages/ThankYouPage.vue';

export default {
  name: "ThankYouPage",
  components: { templateThankYouPage },
};
